/**
 * Calily - Medications Page
 * Medication tracking and management
 *
 * Author: Ava Raper
 * Version: 2.0
 */

import React from 'react';
import MedCard from '../MedCard';

const MedicationsPage = () => {
  return (
    <div className="page-single">
      <MedCard />
    </div>
  );
};

export default MedicationsPage;